import type { UserInfoVO } from '@rendora/common/entities/user';
import { PageKey } from '~/constants/page';

// 等级类型
export enum USER_LEVEL_KEY {
  UN_AUTHORIZED = -1, // 企业未认证
  TASTE = 1, // 体验版
  PERSONAL_LITE = 3, // 个人入门
  // PERSONAL_PRO = 10, // 个人标准版
  PERSONAL = 10, // 个人标准版
  // PERSONAL_PRO = 11, // 个人pro商用
  // ORG_ORDINARY = 20, // 企业基础
  TEAM_TASTE = 15, // 团队体验
  TEAM_LIGHT = 16, // 团队入门
  ORG_STANDARD = 21, // 企业标准
  ORG_FLAGSHIP = 22, // 企业旗舰
  // ORG_CUSTOMIZE = 23, // 企业定制
}
// “企业版” rights_type，用于显示
export enum SHOW_ORG_KEY {
  ORG_SHOW = 24,
}
export const ORG_KEY = 24;
export enum ORG_TYPE {
  // organization_type
  TEAM_MEMBER = 0, // 团队成员
  MODULE_ENTERPRISE_MEMBER = 1, // 模块企业成员
  PERSON = 2, // 个人企业成员（即个人账号）
}

// 授权状态
export enum ACCREDIT_STATUS {
  WAIT = 1, // 授权中
  SUCCESS = 2, // 已授权
  REJECT = 3, // 拒绝授权
}

// pgc签约状态
export enum PGC_STATUS {
  WAIT = 0, // 待提交
  APPROVE = 1, // 待审批(已提交待审核)
  REJECT = 2, // 已驳回(已提交不通过)
  PASS = 3, // 已通过(已提交审核通过)
  REVOKE = 4, // 已撤回
  FINISH = 5, // 已完成
  APPROVING = 9, // 审批中
}

export interface LoginRequestData {
  mobile: string;
  password?: string;
  sms_code?: string;
}

export interface UTMRequestData {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
}

export interface LoginEmailRequestData extends UTMRequestData {
  rsa_key_id: number;
  auth_data: string;
  source?: string;
  country?: string;
}

export interface RegisterEmailRequestData extends UTMRequestData {
  rsa_key_id: number;
  auth_data: string;
  source?: string;
  link_code?: string;
  from_ppt_activity?: number;
  channel_code?: string;
  country?: string;
}

// export interface LoginPhoneRequestData {

// }

export interface LoginInfo {
  create_time: string;
  id: number;
  is_expired: boolean;
  user_id: number;
  key: string;
  expire_in: string;
  expire_time: string;
  name: string;
  is_identify: boolean;
  phone_number: string;
  email_address: string;
  logo_url: string;
  account_name: string;
  username: string;
  rights_type: USER_LEVEL_KEY;
  org_name: string;
  organization_type: ORG_TYPE;
  permission: number;
  is_new_user?: boolean;
  is_active_user: boolean; // 是否是有效用户
  invitation_info?: {
    user_id: number;
    organization_id: string;
  };
  session_id: string;
}
export type { LimitMegabyte } from '@rendora/common/entities/user';

export interface UserInfo extends UserInfoVO {}

// export interface UserInfo extends UserInfoVO {
// 2024-11-14 新增微信 opneid
// openid: string;
// // 2025-07-02 新增飞书 feishu_openid
// feishu_openid?: string;
// // 2024-06-14 同步新字段
// status: number;
// is_kicked_user: boolean;
// start_time: null;
// is_new_user?: boolean; // 是否是新注册用户
// profile_url: string; // 用于展示的头像，个人/团队用
// account_id: number;
// account_name: string;
// contact_details: string;
// current_order_id: number;
// credit_coin: number;
// end_time: string;
// login_name: string;
// expired_time: string;
// create_time: string;
// is_available_first_buy: boolean;
// is_expired: boolean;
// is_identify: boolean;
// logo_path: string;
// logo_url: string;
// default_logo_url: string;
// odd_sub_account_seat_count: number;
// org_logo_url: string;
// organization_admin_user: boolean;
// organization_id: number;
// organization_name: string;
// organization_type: number;
// organization_create_time: string;
// permission: number;
// is_edit_logo: boolean; // 是否可修改团队 logo
// platform_logo_path: string;
// platform_logo_url: string;
// default_platform_logo_url: string;
// phone_number: string;
// email_address?: string;
// personal_expired_time: string;
// packet_total_buy_more_credit_coin: number;
// packet_used_buy_more_credit_coin: number;
// current_package_expired_time: string; // 当前套餐到期时间
// current_total_credit_coin: number; // 当前套餐总言币
// current_remained_credit_coin: number; // 当前套餐剩余言币
// account_total_credit_coin: number; // 账户套餐总言币
// account_remained_credit_coin: number; // 账户套餐剩余言币
// current_buy_more_total_credit_coin: number; // 当前总加购言币
// current_buy_more_remained_credit_coin: number; // 当前剩余加购言币
// account_buy_more_total_credit_coin: number; // 账号总加购言币
// account_buy_more_remained_credit_coin: number; // 账号剩余加购言币
// current_activity_total_credit_coin: number; // 当前套餐总言币
// current_activity_remained_credit_coin: number; // 当前套餐剩余言币
// account_activity_total_credit_coin: number; // 当前套餐总言币
// apply_credit_coin_expired_time: number; // 当前套餐到期时间
// account_activity_remained_credit_coin: number; // 当前套餐剩余言币
// free_account_total_credit_coin: number; // 试用账号总言币
// free_account_credit_coin_expired_time: number; // 试用账号言币过期时间
// free_account_remained_credit_coin: number; // 试用账号剩余言币
// rights: {
//   authorization_identify_num: number; // 剩余转授权
//   credit_coin: number; // 剩余言币
//   rendering_channel_num: number; // 剩余渲染通道数
//   storage: number; // 剩余存储， B，字节
//   sub_account_num: number; // 剩余子账号数量
//   taste_used_coin: number; // 体验已使用言币
//   taste_all_coin: number; // 体验总言币
//   total_authorization_identify_num: number; // 总转授权
//   total_credit_coin: number; // 当前生效的总言币（本月/本年）
//   total_storage: number; // 存储总量， B，字节
//   total_sub_account_num: number; // 总子账号数量
//   account_all_coin: number; // 剩余总言币
//   account_all_used_coin: number; // 剩余总言币消耗的言币
//   total_used_storage: number; // b 使用总量
// };
// rights_type: USER_LEVEL_KEY & SHOW_ORG_KEY;
// rights_name: string;
// rights_time_identity: string;
// rights_id: number;
// user_id: number;
// ma_info_id: number;
// used_credit_coins: number;
// username: string;
// member_can_visible_pay_view_page: boolean;
// config_type: number;
// rights_record: {
//   render_pass: number;
//   speed: number;
//   max_resolution: number;
//   file_upload_type: string;
//   video_download_type: string;
//   watermark: number;
//   recycle: number;
//   single_video_max_duration: number;
//   publish: number;
//   team_work: number;
//   one_coin_time: number;
//   speed_up_coin: number;
//   font_limit: number;
//   audio_limit: number;
//   image_limit: number;
//   video_limit: number;
//   ppt_limit: number;
//   pdf_limit: number;
//   credit_coin_time: number;
//   time_identity: string;
//   limit_megabyte: LimitMegabyte;
//   rending_video_options: object; // 渲染配置
//   allow_add_coin: boolean; // 是否允许加购言币
//   allow_add_storage: boolean; // 是否允许加购存储
//   allow_add_account: boolean; // 是否允许加购子账号
//   online_room_use_time_limit: number; // 在线房间使用时间限制，单位：秒
// };
// identify_info?: {
//   name?: string;
//   identify_no?: string;
//   status: USER_VERIFY_STATUS;
// };
// }

export interface Session {
  user_id: number;
  key: string;
  session_id: string;
}

export interface ChangePhoneRequestData {
  mobile?: string;
  sms_code: string;
  email?: string;
}

export interface PublicKeyData {
  public_key: string;
  id: number;
}

export interface CompanyInfoData {
  name: string;
  avatar_url: string;
  background_cover_url: string;
}

export interface ProjectLogItem {
  id: number;
  title: string;
  introduce_picture_url: string;
  describe_content: string[];
}

export interface UserAwardInfo {
  personal_experience_register_info?: {
    // 个人体验注册权益
    credit_coins: number;
    expired_time: number;
  };
  attraction_register_reward?: {
    // 拉新注册奖励
    credit_coins: number;
    expired_time: number;
  };
  org_experience_register_info: {
    // 拉新注册奖励
    credit_coins: number;
    expired_time: number;
  };
  product_update_notice: {
    id: number;
    version_number: string;
    tab_card_list: ProjectLogItem[];
  };
}

export interface CreateTasteOrgData {
  organization_name: string;
  account_name: string;
  email: string | undefined;
  num_of_users: string;
  company_industry?: number;
  other_industry?: string;
}

export interface CreateTasteOrgResponse {
  account_info: UserInfo;
  user_id: number;
  key: string;
}

export interface CreateStarterOrgData {
  organization_name: string;
  nick_name: string;
  email: string;
  num_of_users: string;
  company_industry?: number;
  other_industry?: string;
}

export interface CreateStarterOrgResponse {
  account_info: UserInfo;
  user_id: number;
  key: string;
}

export interface UserInvoiceInfo {
  invoice_type: number;
  invoice_type_name?: string;
  ident_name: string;
  receiver_email: string;
  ident_code?: string;
  order_ids?: string[];
}

export interface InvoiceOrder {
  id: number;
  order_id: string;
  rights_name: string;
  ident_name: string;
  ident_code: string;
  receiver_email: string;
  invoice_type: number;
  total_fee: number;
  status: number;
  failed_reason: string;
  create_account_id: number;
  operate_staff_id: number;
  apply_time: string;
  finished_time: string;
  create_time: string;
  update_time: string;
}

export interface Member {
  account_id: number;
  account_name: string;
  create_time: string;
  email_address: string;
  is_active_user: boolean;
  is_kicked_user: boolean;
  logo_url: string;
  permission: number;
  phone_number: string;
  user_credit_coins: number;
  user_storage: number;
  user_id: number;
  username: string;
}

export interface AccreditInfo {
  id: number;
  status: number;
  reward_coin: number;
  reward_coin_expire_days: number;
  is_my_sign_record: boolean;
  sign_info: {
    id: number;
    notice_content: string; // 通知内容
    authorization_certificate_file_path: string; // 授权书路径
    authorization_certificate_file_url: string; // 授权书链接
    editor_user_id: number; // 编辑用户id
    create_time: string; // 创建时间
    uer_sign_status: ACCREDIT_STATUS; // 状态
    reward_coin: number;
    reward_coin_expire_days: number;
  };
}

export interface PgcRecord {
  id: number;
  organization_name: string; // 团队名称
  organization_admin_mobile: string; // 团队管理员电话
  account_id: number;
  character_id?: number; // 人物id
  organization_id: number;
  order_id: string; // 订单号
  status: PGC_STATUS;
  user_email: string; // 用户提交时的邮箱
  business_email: string; // 后台下单时的商务邮箱
  token: string;
  is_viewed: true; // 管理员是否查看过
  images?: string[]; // 用户上传的六视图
  reject_reason: string; // 驳回原因
  suggested_changes: string; // 修改建议
  create_time?: string;
  update_time?: string;
  submit_time?: string; // 用户提交审核时间
  reject_time?: string; // 管理员驳回时间
  approve_time?: string; // 管理员通过时间
  revoke_time?: string; // 用户撤回时间
  estimated_completion_time?: string; // 预计完成时间
  completion_time?: string; // 实际制作完成时间
  cover_url?: string; // 人物角色图
}

export interface PgcSubmitParams {
  token: string;
  images: string[];
  user_email: string;
}

export interface PgcFiveView {
  id: number;
  images: {
    position_locale_name: string;
    position_name: string;
    url: string;
  }[];
  cover: string;
  videos: string[];
  character_id: number;
  character_look_name: string;
}

export interface PgcImageCheckResult {
  status: 'pending' | 'completed' | 'executing' | 'failed';
  result: {
    image_url: string;
    has_face: boolean; // 是否有人脸
    pose: 'left_90' | 'left_45' | 'front' | 'right_45' | 'right_90' | 'invalid'; //  位置
    is_exp_neutral: boolean; // 表情检测
    is_valid: boolean; // 是否合法
    error_msg: string[];
    error_description: string[];
  }[];
  error?: string;
}

export interface PageActionMap {
  [PageKey.HOME]: [
    // 'home_banner',
    // 'home_highlight',
    // 'home_app_case',
    // 'home_create_same_style',
    'home_top', // 首页置顶
    'home_search', // 全局搜索
    'home_character', // 首页3D数字人
    'home_scenarios', // 首页应用场景
    'home_templates', // 首页模板列表
  ];
  [PageKey.TEMPLATE]: [];
  [PageKey.CHARACTER]: [];
  [PageKey.SCENARIOS]: [];
  [PageKey.SUBSCRIBE]: [];
  [PageKey.RECENTLY_WORKS]: [];
  [PageKey.HELP_CENTER]: [];
  [PageKey.TUTORIAL]: [];
  [PageKey.ACADEMY]: [];
  [PageKey.MY_COLLECTION]: [
    'my_collection_source_merge',
    'my_collection_source_click',
    'my_collection_share_to_outer_user',
    'my_collection_source_from',
  ];
  [PageKey.PERSONAL_SPACE]: [
    'personal_space_share_to_outer_user',
    'personal_space_queue_acceleration',
    'personal_space_chengpian_promotion',
  ];
  [PageKey.TEAM_SPACE]: [
    'team_space_share_to_outer_user',
    'team_space_chengpian_avatar_route',
    'team_space_chengpian_promotion',
    'team_space_publish_to_platform',
  ];
  [PageKey.BRAND_MANAGE]: ['brand_manage_follow'];
  [PageKey.CENTER_ACCOUNT]: [
    'center_account_set_account_info',
    'center_account_change_bind_phone',
    'center_account_change_password',
    'center_account_change_verify_info',
    'center_account_bind_account',
    'center_account_change_basic_info',
  ];
  [PageKey.CENTER_MEMBER]: [
    'center_member_change_team_name',
    'center_member_logo_config',
    'center_member_transfer_administrator',
    'center_member_manage_team_member',
    'center_member_add_team_member_by_link',
    'center_member_add_team_member_by_normal',
    'center_member_show_team_member_login_account',
    'center_member_cancellation',
  ];
  [PageKey.CENTER_EQUITY]: ['center_equity_view_equity'];
  [PageKey.CENTER_ORDER]: ['center_order_order', 'center_order_invoice'];
  [PageKey.CENTER_CONSUME]: [];
  [PageKey.PERSONAL_PAGE]: ['personal_page_up_and_down_shelves', 'personal_page_member_view'];
}

export type GenericActionKey =
  | 'click_logo_redirect'
  | 'message_center_entrance'
  | 'float_comps'
  | 'wechat_consult'
  | 'phone_consult'
  | 'book_demonstration'
  | 'feedback_portal'
  | 'human_customer_service'
  | 'industry_app_cases'
  | 'creative_camp_qr_code'
  | 'switch_accounts'
  | 'logout'
  | 'change_avatar'
  | 'product_update_doc'
  | 'new_works'
  | 'new_works_nav'
  | 'create_try_team'
  | 'package_upgrade'
  | 'avatar_edit'
  | 'chengpian_promotion_publish'
  | 'chengpian_share_to_outer_user';

export interface Action<K extends string = string> {
  key: K;
  name: string;
  hasPermission?: boolean;
}

type ArrayType<T> = T extends (infer U)[] ? U : never;

export interface PageWithActionPermission<T extends keyof PageActionMap = keyof PageActionMap> {
  key: T;
  hasPermission: boolean;
  name: string;
  actions?: Action<ArrayType<PageActionMap[T]>>[];
}

export interface Permission {
  pages?: PageWithActionPermission<keyof PageActionMap>[];
  config?: {
    logo_url?: '';
    logo_click_url?: '';
    logout_url?: '';
    head_icon_url?: '';
  };
  genericActions?: Action<GenericActionKey>[];
}

export interface TeamMemberAccount {
  rsa_key_id: number;
  name: string;
  login_name: string;
  auth_data: string;
}

export interface EditTeamMemberAccount {
  id: number;
  name?: string;
  rsa_key_id?: number;
  auth_data?: string;
}

export interface AuthThirdRequest {
  auth_session: string;
}

export interface AuthThirdResponse {
  user_id: number;
  key: string;
  expire_time: number;
  expire_in: number;
  session_id: string;
}

export interface HaierLoginRequest {
  token: string;
}
